document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('#ContactFooterNewsletter');
  const messageContainer = document.querySelector('#newsletter-message-{{ section.id }}');

  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault(); // 阻止默认提交

    const emailInput = form.querySelector('input[name="contact[email]"]');
    const email = emailInput.value.trim();

    if (!email) return;

    // 检查本地存储中是否已订阅
    if (localStorage.getItem('subscribed-' + email)) {
      messageContainer.innerHTML = '<p class="newsletter-error">You have already subscribed. Please do not submit again.</p>';
      return;
    }

    // Ajax 异步提交
    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
    })
    .then(response => response.text())
    .then(() => {
      messageContainer.innerHTML = '<p class="newsletter-success">Thank you for subscribing!</p>';
      localStorage.setItem('subscribed-' + email, 'true'); // 标记已订阅
      form.reset();
    })
    .catch(() => {
      messageContainer.innerHTML = '<p class="newsletter-error">An error occurred. Please try again later.</p>';
    });
  });
});
